import React from 'react'
import { Button } from '@/shared/ui'
import { computePaidOk } from '@/modules/auth/utils/subscriptionGate'

type DuplicateInfo = {
  subscription_id?: string | null
  status?: string | null
  current_period_end?: string | null
  trial_ends_at?: string | null
  is_trial?: boolean | null
  period_valid?: boolean | null
  message?: string | null
  email?: string | null
}

type Props = {
  info: DuplicateInfo
  email?: string | null
  syncing?: boolean
  onRetry?: () => void
  onOpenPortal?: () => void
  onGoPlans?: () => void
}

export default function CheckoutDuplicateSubscriptionAlert({
  info,
  email,
  syncing,
  onRetry,
  onOpenPortal,
  onGoPlans,
}: Props) {
  const periodValid =
    typeof info?.period_valid === 'boolean'
      ? info.period_valid
      : computePaidOk(info as any)
  const emailText = (email || info?.email || '').trim()
  const title = periodValid
    ? 'Assinatura ativa encontrada'
    : 'Assinatura vencida detectada'
  const description = periodValid
    ? `Encontramos uma assinatura ativa${emailText ? ` para ${emailText}` : ''}. Para evitar duplicidade, gerencie o pagamento ou altere o plano.`
    : `Sua assinatura esta vencida${emailText ? ` (${emailText})` : ''}. Clique em "Renovar agora" para sincronizar e concluir o pagamento.`

  return (
    <div className="mb-4 rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-sm text-foreground">
      <div className="font-medium">{title}</div>
      <div className="mt-1 text-foreground/80">{description}</div>
      {syncing && (
        <div className="mt-2 text-xs text-foreground/70">
          Sincronizando com o Stripe...
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        {periodValid ? (
          <>
            {onOpenPortal && (
              <Button onClick={onOpenPortal}>Abrir portal Stripe</Button>
            )}
            {onGoPlans && (
              <Button variant="outline" onClick={onGoPlans}>
                Ir para meus planos
              </Button>
            )}
          </>
        ) : (
          <>
            {onRetry && (
              <Button onClick={onRetry} disabled={!!syncing}>
                Renovar agora
              </Button>
            )}
            {onOpenPortal && (
              <Button variant="outline" onClick={onOpenPortal}>
                Abrir portal Stripe
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  )
}
